import React, { useState, useEffect } from 'react';

import axiosInstance from '../lib/axios';
import { toast } from 'sonner';
import { Button } from './ui/button';
import { Textarea } from './ui/textarea';
import PromptImprover from './PromptImprover';
import { FileText, Loader2 } from 'lucide-react';



const DocumentPromptPanel = ({ documentId, currentPrompt, onUpdate }) => {

  const [prompt, setPrompt] = useState(currentPrompt || '');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setPrompt(currentPrompt || '');
  }, [currentPrompt]);

  const handleSave = async () => {
    setSaving(true);
    try {
      await axiosInstance.put(
        `/documents/${documentId}`,
        { system_prompt: prompt }
      );
      onUpdate(prompt);
      toast.success('Prompt del documento actualizado');
    } catch (error) {
      toast.error('Error al guardar prompt');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3">
        <div className="bg-gradient-to-br from-sky-500 to-blue-600 p-3 rounded-xl shadow-lg">
          <FileText className="w-6 h-6 text-white" />
        </div>
        <div>
          <h3 className="font-semibold text-lg">System Prompt del Documento</h3>
          <p className="text-sm text-slate-600 dark:text-slate-300">
            Define cómo la IA interactúa con este documento específico
          </p>
        </div>
      </div>

      <div className="space-y-2">
        <div className="flex justify-between items-center">
          <label className="text-sm font-medium">Prompt personalizado</label>
          <PromptImprover
            currentPrompt={prompt}
            onImproved={(improved) => setPrompt(improved)}
          />
        </div>
        <Textarea
          data-testid="document-prompt-input"
          placeholder="Eres un asistente especializado para este documento. Ayuda al usuario con..."
          value={prompt}
          onChange={(e) => setPrompt(e.target.value)}
          rows={10}
          className="resize-none font-mono text-sm"
        />
        <p className="text-xs text-slate-500 dark:text-slate-400">
          Este prompt solo se aplicará a las conversaciones relacionadas con este documento.
          Si está vacío, se usará un prompt por defecto.
        </p>
      </div>

      <Button
        data-testid="save-document-prompt"
        onClick={handleSave}
        disabled={saving}
        className="w-full bg-gradient-to-r from-sky-500 to-blue-600 hover:from-sky-600 hover:to-blue-700"
      >
        {saving ? (
          <>
            <Loader2 className="w-4 h-4 mr-2 animate-spin" />
            Guardando...
          </>
        ) : (
          'Guardar Prompt del Documento'
        )}
      </Button>
    </div>
  );
};

export default DocumentPromptPanel;
